import { render } from "./StoredObjectItem.vue?vue&type=template&id=f86e763c"
import script from "./StoredObjectItem.vue?vue&type=script&lang=js"
export * from "./StoredObjectItem.vue?vue&type=script&lang=js"

import "./StoredObjectItem.vue?vue&type=style&index=0&id=f86e763c&lang=css"

import exportComponent from "F:\\projects\\Cloutlayer\\Cloutlayer\\Source\\webapp\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__